// src/components/MobileHeader.js
import React, { useState, useRef, useEffect, useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom'; // Added useNavigate [cite: 533]
import { FiSun, FiMoon, FiLogOut, FiBell, FiSettings } from 'react-icons/fi';
import { AuthContext } from '../context/AuthContext';
import logo from '../assets/Service-manager.png';

const MobileHeader = ({ onLogout, isDarkMode, toggleDarkMode }) => {
    const { user } = useContext(AuthContext);
    const navigate = useNavigate(); // [cite: 533]
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    
    const [permissionStatus, setPermissionStatus] = useState(
        ('Notification' in window) ? Notification.permission : 'unsupported'
    );

    const dropdownRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsDropdownOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const requestNotificationPermission = async () => {
        if (!('Notification' in window)) return;
        try {
            const permission = await Notification.requestPermission();
            setPermissionStatus(permission);
        } catch (e) {
            console.error(e);
        }
    };

    if (!user) return null;

    const userInitial = user.name ? user.name.charAt(0).toUpperCase() : '?';

    return (
        <header className="mobile-header">
            <Link to="/" className="mobile-header-logo-link">
                <img src={logo} alt="Ramco Logo" className="mobile-header-logo" />
            </Link>

            <div className="mobile-header-actions">
                <div className="user-menu" ref={dropdownRef}>
                    <div
                        className="user-avatar-container"
                        onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                        title={user.name}
                    >
                        {user.profilePictureUrl ? (
                            <img src={user.profilePictureUrl} alt={user.name} className="user-avatar" />
                        ) : (
                            <div className="user-avatar">{userInitial}</div>
                        )}
                    </div>

                    {isDropdownOpen && (
                        <div className="user-dropdown">
                            {/* Settings button added to the profile pop-out  */}
                            <button 
                                onClick={() => { navigate('/settings'); setIsDropdownOpen(false); }} 
                                className="dropdown-item"
                            >
                                <FiSettings size={18} />
                                <span>Settings</span>
                            </button>

                            {permissionStatus !== 'granted' && (
                                <button onClick={requestNotificationPermission} className="dropdown-item">
                                    <FiBell size={18} />
                                    <span>Enable Notifications</span>
                                </button>
                            )}

                            <button onClick={toggleDarkMode} className="dropdown-item">
                                {isDarkMode ? <FiSun size={18} /> : <FiMoon size={18} />}
                                <span>{isDarkMode ? 'Light Mode' : 'Dark Mode'}</span>
                            </button>

                            <button onClick={onLogout} className="dropdown-item">
                                <FiLogOut size={18} />
                                <span>Logout</span>
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </header>
    );
};

export default MobileHeader;